module.exports = __webpack_public_path__ + "static/media/close-icon.5b5f0e89.svg";